import { useAppSelector } from "../Utils/customHooks";
// Custom hook to get token
export const UseAuthToken = () => {
  return useAppSelector(state => state.signin.token);
};

export function formatNumber(num:number) {
  if (num >= 1_000_000_000) {
    return (num / 1_000_000_000).toFixed(1).replace(/\.0$/, "") + "B"; // Billion
  } else if (num >= 1_000_000) {
    return (num / 1_000_000).toFixed(1).replace(/\.0$/, "") + "M"; // Million
  } else if (num >= 1_000) {
    return (num / 1_000).toFixed(1).replace(/\.0$/, "") + "K"; // Thousand
  }
  return num.toString(); // Less than 1000, return as is
}
